<template>
  <v-app>
    <register-form
      v-if="!isVerifying && !isVerified"
      :initialCode="code"
      :codeError="verifyError"
      @codeAdded="codeAdded"
    ></register-form>

    <div v-if="isVerifying" class="centered">
      <v-progress-circular
        :size="100"
        :width="12"
        color="primary"
        indeterminate
      ></v-progress-circular>
      Verifying...
    </div>

    <password-form
      v-if="isVerified && !isVerifying"
      @didUpdatePassword="didUpdatePassword"
    ></password-form>

    <v-snackbar v-bind="alert" :color="alertColor" multi-line top>
      {{ alertText }}
      <v-btn dark text @click="alert = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import RegisterForm from "@/components/auth/RegisterForm.vue";
import PasswordForm from "@/components/auth/PasswordForm.vue";
import api from "@/services/api.js";

/*
  Code: EJVBVS
  User: admin@brokerage2.com
*/

export default {
  name: "register",
  data() {
    return {
      code: "",
      verifyError: "",
      isVerifying: false,
      isVerified: false,
      alert: false,
      alertText: "There was an error validating this invite code.",
      alertColor: "error",
    };
  },
  methods: {
    showChangePassword() {
      this.isVerified = true;
      this.isVerifying = false;
    },
    codeAdded(code) {
      this.code = code;
      this.verifyCode();
    },
    verifyCode() {
      if (this.code !== "") {
        this.isVerifying = true;

        api
          .checkInviteCode(this.code)
          .then((response) => {
            if (
              response.data.id !== undefined &&
              response.data.password !== undefined
            ) {
              this.$store
                .dispatch("auth/login", {
                  email: response.data.id,
                  password: response.data.password,
                })
                .then(() => {
                  if (this.session.access_token !== null) {
                    this.loadUser();
                  } else {
                    this.isVerifying = false;
                    this.isVerified = false;

                    this.alertText =
                      "There was an error getting your access token.";
                    this.alertColor = "error";
                    this.alert = true;
                  }
                })
                .catch((e) => {
                  console.log("error.......");
                  console.log(e);
                  this.isVerifying = false;
                  this.isVerified = false;

                  this.alertText =
                    "There was an error authenticating your user.";
                  this.alertColor = "error";
                  this.alert = true;
                });
            }
          })
          .catch((e) => {
            console.log("error.......");
            console.log(e.response);

            this.isVerifying = false;
            this.isVerified = false;

            this.alertText = "There was an error validating this invite code.";
            this.alertColor = "error";
            this.alert = true;
          });
      }
    },
    loadUser() {
      this.$store
        .dispatch("user/loadMe")
        .then(() => {
          if (this.me.id !== null) {
            this.showChangePassword();
          } else {
            this.isVerifying = false;
            this.isVerified = false;

            this.alertText = "Error, user ID is missing.";
            this.alertColor = "error";
            this.alert = true;
          }
        })
        .catch((e) => {
          console.log("error: " + e);
          this.isVerifying = false;
          this.isVerified = false;

          this.alertText = "Error while loading user profile.";
          this.alertColor = "error";
          this.alert = true;
        });
    },
    didUpdatePassword(password) {
      let update = {
        password: password,
      };

      this.$store
        .dispatch("user/updateMe", update)
        .then(() => {
          this.alertText = "Password successfully set.";
          this.alertColor = "success";
          this.alert = true;
          setTimeout(this.showLogin, 2000);

          // code below commented out as this.creds is null,
          // due to vuex store not actually saving the creds per conditional logic in stores auth/actions login()

          // let updatedCreds = {
          //   email: this.creds.email,
          //   password: password,
          // };
          // this.$store.commit("auth/setCreds", updatedCreds);
          //
          // if (this.isAdmin) {
          //   console.log("inside didUpdatePassword this.isAdmin true");
          //
          //   this.loadUserAgents();
          // } else {
          //   console.log("inside didUpdatePassword this.isAdmin is false...");
          //
          //   this.$router.push("console");
          // }
        })
        .catch((e) => {
          this.alertText = "Error while updating user password.";
          this.alertColor = "error";
          this.alert = true;
          console.log("didUpdatePassword error: " + e);
        });
    },
    loadUserAgents() {
      this.$store
        .dispatch("user/loadMyAgents")
        .then(() => {
          this.$router.push("console");
        })
        .catch((e) => {
          console.log(e);
          this.$router.push("console");
        });
    },
    showLogin() {
      console.log("Redirect to login");
      this.$router.push("login");
    },
  },
  computed: {
    ...mapGetters("auth", ["session", "isAuthing", "creds"]),
    ...mapGetters("user", ["me", "isLoadingMe", "isAdmin"]),
  },
  mounted() {
    console.log(this.$route.query);
    if (this.$route.query && this.$route.query.code !== undefined) {
      this.code = this.$route.query.code;
      this.verifyCode();
    }
  },
  created() {},

  components: {
    RegisterForm,
    PasswordForm,
  },
};
</script>

<!-- styling for the component -->
<style scoped>
.centered {
  margin: auto;
  height: 120px;
  width: 120px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
</style>
